export { default } from './SupportBlock';
export type { Props, Props as SupportBlockProps } from './SupportBlock';
